import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Endpoints } from '../../environments/endpoints';
import { ConsumeService } from './consume.service';
import { IFavoriteReq } from '../model/http/myFavourites.model';
import { FavoriteChangeResponse, IProducts } from '../model/http/myActivity.model';
import { IProductsRes } from '../model/http/myActivity.model';
import { LocalStorageService } from './local-storage.service';
import { IGeneralResponse } from '../model/http/general-response.model';
import { QuotationFilterKey, QuotationFilters } from '../model/local/quotation.model';

@Injectable({
  providedIn: 'root',
})
export class FavoritesService {
  private activeFilters: QuotationFilters = {
    code: [],
    description: []
  };
  constructor(
    private consume: ConsumeService
  ) {}
  saveDeleteFavorite(
    typeAction: string,
    favoritesData: IFavoriteReq[],
    priceList: number
  ): Observable<IGeneralResponse> {
    return this.consume.httpPost(
      `${Endpoints.favorites.saveDelete}/${typeAction}/products/${priceList}`,
      favoritesData
    );
  }
  checkFavorite(queryParams: string): Observable<FavoriteChangeResponse> {
    return this.consume.httpGet<FavoriteChangeResponse>(
      `${Endpoints.favorites.checkFavorite}${queryParams}`
    );
  }
}
